Object.defineProperty(exports, "__esModule", {
    value: true
});
var _async_to_generator = require("@swc/helpers/_/_async_to_generator");
var _to_consumable_array = require("@swc/helpers/_/_to_consumable_array");
var require_tool = require('../utils/tool.cjs');
var require_global = require('../global.cjs');
var require_share = require('../utils/share.cjs');
require('../utils/index.cjs');
var require_preload = require('../utils/preload.cjs');
var require_index$1 = require('./snapshot/index.cjs');
var _module_federation_sdk = require("@module-federation/sdk");
//#region src/plugins/generate-preload-assets.ts
function splitId(id) {
    var splitInfo = id.split(":");
    if (splitInfo.length === 1) return {
        name: splitInfo[0],
        version: void 0
    };
    else if (splitInfo.length === 2) return {
        name: splitInfo[0],
        version: splitInfo[1]
    };
    else return {
        name: splitInfo[1],
        version: splitInfo[2]
    };
}
function traverseModuleInfo(globalSnapshot, remoteInfo, traverse, isRoot) {
    var memo = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {}, remoteSnapshot = arguments.length > 5 ? arguments[5] : void 0;
    var _require_global_getInfoWithoutType = require_global.getInfoWithoutType(globalSnapshot, require_tool.getFMId(remoteInfo)), snapshotValue = _require_global_getInfoWithoutType.value;
    var effectiveRemoteSnapshot = remoteSnapshot || snapshotValue;
    if (effectiveRemoteSnapshot && !(0, _module_federation_sdk.isManifestProvider)(effectiveRemoteSnapshot)) {
        traverse(effectiveRemoteSnapshot, remoteInfo, isRoot);
        if (effectiveRemoteSnapshot.remotesInfo) {
            var remoteKeys = Object.keys(effectiveRemoteSnapshot.remotesInfo);
            for (var key of remoteKeys){
                if (memo[key]) continue;
                memo[key] = true;
                var subRemoteInfo = splitId(key);
                var remoteValue = effectiveRemoteSnapshot.remotesInfo[key];
                traverseModuleInfo(globalSnapshot, {
                    name: subRemoteInfo.name,
                    version: remoteValue.matchedVersion
                }, traverse, false, memo, void 0);
            }
        }
    }
}
var isExisted = (type, url)=>{
    return document.querySelector(`${type}[${type === "link" ? "href" : "src"}="${url}"]`);
};
function generatePreloadAssets(origin, preloadOptions, remote, globalSnapshot, remoteSnapshot) {
    var cssAssets = [];
    var jsAssets = [];
    var entryAssets = [];
    var loadedSharedJsAssets = /* @__PURE__ */ new Set();
    var loadedSharedCssAssets = /* @__PURE__ */ new Set();
    var options = origin.options;
    var rootPreloadConfig = preloadOptions.preloadConfig;
    var depsRemote = rootPreloadConfig.depsRemote;
    traverseModuleInfo(globalSnapshot, remote, (moduleInfoSnapshot, remoteInfo, isRoot)=>{
        var _moduleInfoSnapshot_modules;
        var preloadConfig;
        if (isRoot) preloadConfig = rootPreloadConfig;
        else if (Array.isArray(depsRemote)) {
            var findPreloadConfig = depsRemote.find((remoteConfig)=>{
                if (remoteConfig.nameOrAlias === remoteInfo.name || remoteConfig.nameOrAlias === remoteInfo.alias) return true;
                return false;
            });
            if (!findPreloadConfig) return;
            preloadConfig = require_preload.defaultPreloadArgs(findPreloadConfig);
        } else if (depsRemote === true) preloadConfig = rootPreloadConfig;
        else return;
        var remoteEntryUrl = (0, _module_federation_sdk.getResourceUrl)(moduleInfoSnapshot, require_tool.getRemoteEntryInfoFromSnapshot(moduleInfoSnapshot).url);
        if (remoteEntryUrl) entryAssets.push({
            name: remoteInfo.name,
            moduleInfo: {
                name: remoteInfo.name,
                entry: remoteEntryUrl,
                type: "remoteEntryType" in moduleInfoSnapshot ? moduleInfoSnapshot.remoteEntryType : "global",
                entryGlobalName: "globalName" in moduleInfoSnapshot ? moduleInfoSnapshot.globalName : remoteInfo.name,
                shareScope: "",
                version: "version" in moduleInfoSnapshot ? moduleInfoSnapshot.version : void 0
            },
            url: remoteEntryUrl
        });
        var moduleAssetsInfo = "modules" in moduleInfoSnapshot ? moduleInfoSnapshot.modules : [];
        var normalizedPreloadExposes = require_preload.normalizePreloadExposes(preloadConfig.exposes);
        if (normalizedPreloadExposes.length && "modules" in moduleInfoSnapshot) moduleAssetsInfo = moduleInfoSnapshot === null || moduleInfoSnapshot === void 0 ? void 0 : (_moduleInfoSnapshot_modules = moduleInfoSnapshot.modules) === null || _moduleInfoSnapshot_modules === void 0 ? void 0 : _moduleInfoSnapshot_modules.reduce((assets, moduleAssetInfo)=>{
            if ((normalizedPreloadExposes === null || normalizedPreloadExposes === void 0 ? void 0 : normalizedPreloadExposes.indexOf(moduleAssetInfo.moduleName)) !== -1) assets.push(moduleAssetInfo);
            return assets;
        }, []);
        function handleAssets(assets) {
            var assetsRes = assets.map((asset)=>(0, _module_federation_sdk.getResourceUrl)(moduleInfoSnapshot, asset));
            if (preloadConfig.filter) return assetsRes.filter(preloadConfig.filter);
            return assetsRes;
        }
        if (moduleAssetsInfo) {
            var assetsLength = moduleAssetsInfo.length;
            for(var index = 0; index < assetsLength; index++){
                var assetsInfo = moduleAssetsInfo[index];
                var exposeFullPath = `${remoteInfo.name}/${assetsInfo.moduleName}`;
                origin.remoteHandler.hooks.lifecycle.handlePreloadModule.emit({
                    id: assetsInfo.moduleName === "." ? remoteInfo.name : exposeFullPath,
                    name: remoteInfo.name,
                    remoteSnapshot: moduleInfoSnapshot,
                    preloadConfig,
                    remote: remoteInfo,
                    origin
                });
                if (require_global.getPreloaded(exposeFullPath)) continue;
                if (preloadConfig.resourceCategory === "all") {
                    var _cssAssets, _cssAssets1, _jsAssets, _jsAssets1;
                    (_cssAssets = cssAssets).push.apply(_cssAssets, _to_consumable_array._(handleAssets(assetsInfo.assets.css.async)));
                    (_cssAssets1 = cssAssets).push.apply(_cssAssets1, _to_consumable_array._(handleAssets(assetsInfo.assets.css.sync)));
                    (_jsAssets = jsAssets).push.apply(_jsAssets, _to_consumable_array._(handleAssets(assetsInfo.assets.js.async)));
                    (_jsAssets1 = jsAssets).push.apply(_jsAssets1, _to_consumable_array._(handleAssets(assetsInfo.assets.js.sync)));
                } else if (preloadConfig.resourceCategory === "sync") {
                    var _cssAssets2, _jsAssets2;
                    (_cssAssets2 = cssAssets).push.apply(_cssAssets2, _to_consumable_array._(handleAssets(assetsInfo.assets.css.sync)));
                    (_jsAssets2 = jsAssets).push.apply(_jsAssets2, _to_consumable_array._(handleAssets(assetsInfo.assets.js.sync)));
                }
                require_global.setPreloaded(exposeFullPath);
            }
        }
    }, true, {}, remoteSnapshot);
    if (remoteSnapshot.shared && remoteSnapshot.shared.length > 0) {
        var collectSharedAssets = (shareInfo, snapshotShared)=>{
            var _ref = require_share.getRegisteredShare(origin.shareScopeMap, snapshotShared.sharedName, shareInfo, origin.sharedHandler.hooks.lifecycle.resolveShare) || {}, registeredShared = _ref.shared;
            if (registeredShared && typeof registeredShared.lib === "function") {
                snapshotShared.assets.js.sync.forEach((asset)=>{
                    loadedSharedJsAssets.add(asset);
                });
                snapshotShared.assets.css.sync.forEach((asset)=>{
                    loadedSharedCssAssets.add(asset);
                });
            }
        };
        remoteSnapshot.shared.forEach((shared)=>{
            var _options_shared;
            var shareInfos = (_options_shared = options.shared) === null || _options_shared === void 0 ? void 0 : _options_shared[shared.sharedName];
            if (!shareInfos) return;
            var sharedOptions = shared.version ? shareInfos.find((s)=>s.version === shared.version) : shareInfos;
            if (!sharedOptions) return;
            require_tool.arrayOptions(sharedOptions).forEach((s)=>{
                collectSharedAssets(s, shared);
            });
        });
    }
    var needPreloadJsAssets = jsAssets.filter((asset)=>!loadedSharedJsAssets.has(asset) && !isExisted("script", asset));
    return {
        cssAssets: cssAssets.filter((asset)=>!loadedSharedCssAssets.has(asset) && !isExisted("link", asset)),
        jsAssetsWithoutEntry: needPreloadJsAssets,
        entryAssets: entryAssets.filter((entry)=>!isExisted("script", entry.url))
    };
}
var generatePreloadAssetsPlugin = function generatePreloadAssetsPlugin() {
    return {
        name: "generate-preload-assets-plugin",
        generatePreloadAssets (args) {
            return _async_to_generator._(function*() {
                var origin = args.origin, preloadOptions = args.preloadOptions, remoteInfo = args.remoteInfo, remote = args.remote, globalSnapshot = args.globalSnapshot, remoteSnapshot = args.remoteSnapshot;
                if (!_module_federation_sdk.isBrowserEnvValue) return {
                    cssAssets: [],
                    jsAssetsWithoutEntry: [],
                    entryAssets: []
                };
                if (require_tool.isRemoteInfoWithEntry(remote) && require_tool.isPureRemoteEntry(remote)) return {
                    cssAssets: [],
                    jsAssetsWithoutEntry: [],
                    entryAssets: [
                        {
                            name: remote.name,
                            url: remote.entry,
                            moduleInfo: {
                                name: remoteInfo.name,
                                entry: remote.entry,
                                type: remoteInfo.type || "global",
                                entryGlobalName: "",
                                shareScope: ""
                            }
                        }
                    ]
                };
                require_index$1.assignRemoteInfo(remoteInfo, remoteSnapshot);
                return generatePreloadAssets(origin, preloadOptions, remoteInfo, globalSnapshot, remoteSnapshot);
            })();
        }
    };
};
//#endregion
exports.generatePreloadAssetsPlugin = generatePreloadAssetsPlugin; //# sourceMappingURL=generate-preload-assets.cjs.map
